import React from 'react'
import axios from 'axios'
import { API, Config } from '../config'
import { AuthService } from '../services'
import AuthStore from '../stores/AuthStore'
import { message } from 'antd'

const instance = axios.create({
  baseURL: API.baseUrl,
})

const requestHandler = (request) => {
  request.headers['Authorization'] = 'Bearer ' + AuthService.getToken() || null
  return request
}

const errorHandler = (error) => {
  if (error.response) {
    // console.log(error)
    if (error.response.status === 401) {
      AuthService.clearToken()
      message.warning(Config.error[error.response.status].message)
      
    }
    if (error.response.status === 422) {
      message.warning(Config.error[error.response.status].message)
    }
    if (error.response.status === 403) {
      message.warning(Config.error[error.response.status].message)
    }
  }
  return Promise.reject({ ...error })
}

const successHandler = (response) => {
  // message.success("OK");
  return response
}

instance.interceptors.request.use((request) => requestHandler(request))
instance.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error),
)

export const Http = instance
